import { render, staticRenderFns } from "./TDschedule.vue?vue&type=template&id=00624638"
import script from "./TDschedule.vue?vue&type=script&lang=js"
export * from "./TDschedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports